import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { getContent } from "src/selectors";
import { Content } from "src/types";

/**
 * Хук для определения типа контента (desktop, laptop, mobile) в зависимости от размера окна и устройства пользователя
 */
export const useContent = () => {
  let content = useSelector(getContent);

  const isMobile = useMediaQuery({ maxAspectRatio: "4/6" });
  const isMobileDevice = new RegExp(
    /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i
  ).test(navigator.userAgent);

  if (isMobile || isMobileDevice) {
    content = "mobile";
  }

  const isLaptop = useMediaQuery({ maxAspectRatio: "1/1", minAspectRatio: "4/6" });

  if (isLaptop) {
    content = "laptop";
  }

  return content as Content;
};
